import { useState } from 'react';
import useSWR from 'swr';
import { route } from 'nextjs-routes';
import { useStore } from '@/hooks';
import FrontendHttpClient from '@/utils/http-handler/frontend-http-client';

export const useDivisions = () => {
  const [divisions, setDivisions] = useState([]);
  const [{ insuredId }] = useStore();

  const { mutate, isValidating, error } = useSWR(
    route({ pathname: '/api/v2/divisions' }),
    {
      onSuccess: response => {
        const divisionData = response.data || [];
        divisionData.sort((a, b) => {
          if (b.amsId === 'GLOBAL') {
            return 1;
          }
          if (a.amsId === 'GLOBAL') {
            return -1;
          }

          return a.name.localeCompare(b.name);
        });

        setDivisions(divisionData);
      },
    }
  );

  const updateCurrentDivisionDefaults = async (
    producerId = null,
    signatureId = null
  ) => {
    if (!insuredId) {
      throw new error('No current insured selected');
    }
    const result = await FrontendHttpClient.get('/api/v2/divisions/current');
    const currentDivision = result?.data;

    try {
      const updateValues = {
        ...currentDivision,
        defaultProducerId: producerId,
        defaultSignatureId: signatureId,
      };
      await FrontendHttpClient.put(
        route({ pathname: `/api/v2/divisions/${currentDivision.id}` }),
        updateValues
      );
    } catch (e) {
      throw new error('error updating current division');
    }
  };

  return {
    divisions,
    updateCurrentDivisionDefaults,
    mutate,
    isValidating,
    error,
  };
};
